export enum BlockTypeEnum {
  FirstLevelTitle = 'first_level_title',
  SecondLevelTitle = 'second_level_title',
  ThirdLevelTitle = 'third_level_title',
  FourthLevelTitle = 'fourth_level_title',
  Fulltext = 'fulltext',
  Question = 'question',
  Table = 'table',
}
